import { Button, Col, Form, Input, Row, Select, Switch, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import servicePath from '../config/apiUrl';
import '../static/css/AddArticle.css';

import { IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css

const { Option } = Select;
const { TextArea } = Input


function AddAd(props) {

    const [hideSW, setHideSW] = useState(false);
    const [showTitle, setShowTitle] = useState(true);
    const [cmData, setcmData] = useState([]);
    const [cId, setcId] = useState();
    const [posturl, setPosturl] = useState();
    const [postFile, setPostFile] = useState(null);
    const [fields, setFields] = useState([]);
    // let adid = props.match.params.id
    const [adId, setAdId] = useState(props.match.params.id)  // 文章的ID，如果是0说明是新增加，如果不是0，说明是修改
    const [adTitle, setAdTitle] = useState('')   //文章标题
    const [description, setDescription] = useState('')   //文章小标题 描述

    // editor 实例
    const [editor, setEditor] = useState(null)   // TS 语法
    // const [editor, setEditor] = useState(null)                   // JS 语法

    // 编辑器内容
    const [richTextContent, setRichTextContent] = useState('<dvi> </dvi>')

    useEffect(() => {
        setAdId(props.match.params.id)
        if (props.match.params.id) {
            getAdInfo()
        }
    }, [props.match.params.id])


    // 工具栏配置
    const toolbarConfig: Partial<IToolbarConfig> = {}  // TS 语法
    // const toolbarConfig = { }                        // JS 语法

    // 编辑器配置
    const editorConfig: Partial<IEditorConfig> = {    // TS 语法
        // const editorConfig = {                         // JS 语法
        placeholder: '请输入内容...',
        MENU_CONF: {}

    }
    editorConfig.MENU_CONF['uploadImage'] = {
        server: servicePath.serverUrl + '/admin/uploadImage',
        // fieldName: 'customImg'
        // 继续写其他配置...
        //【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
    }


    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])



    //获取编辑广告的默认数据
    const getAdInfo = () => {
        const hide = message.loading('...', 0);
        axios({
            method: 'get',
            url: servicePath.getAdInfo + "/" + adId,
            // withCredentials: true,
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                setTimeout(hide, 100);
                if (res.data.code == 1) {
                    setPosturl(res.data.data.post_url)

                    let resData = res.data?.data || {}
                    setHideSW(resData.hide == 1 ? 0 : 1)
                    setShowTitle(resData.show_title == 1 ? 1 : 0)
                    setRichTextContent(resData.rich_text_content)
                    setAdId(resData.adId)
                    console.log("广告信息：", resData)

                    setFields([
                        // {
                        //   name:['user', 'adId'],
                        //   value: resData.adId,
                        // },
                        {
                            name: ['user', 'adTitle'],
                            value: resData.title,
                        },
                        {
                            name: ['user', 'description'],
                            value: resData.description,
                        },
                        {
                            name: ['user', 'type_id'],
                            value: resData.type_id,
                        }, {
                            name: ['user', 'post_url'],
                            value: resData.post_url,
                        }
                    ])

                } else {
                    console.log("未查到相关广告数据:", res.data)
                }


            }
        )

    }

    const validateMessages = {
        required: '${label} 必须填写!',
        types: {
            email: '${label} is not validate email!',
            number: '${label} is not a validate number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };

    const onFinish = values => {
        const key = 'addData';
        let fromData = values.user;
        if (!fromData.adTitle) {
            message.error('标题不能为空')
            return false
        } if (!fromData.description) {
            message.error('小标题（描述）不能为空')
            return false
        } if (!fromData.type_id) {
            message.error('广告类型不能为空')
            return false
        } else if (!postFile && !posturl) {
            message.error('海报图片不能为空')
            return false
        } else if (!richTextContent) {
            message.error('广告页面详情内容')
            return false
        }

        var formData = new FormData();
        formData.append("title", fromData.adTitle);
        formData.append("description", fromData.description);
        formData.append("type_id", fromData.type_id);
        formData.append("hide", hideSW ? 0 : 1);
        formData.append("show_title", showTitle ? 1 : 0);
        formData.append("data_url", fromData.data_url);
        formData.append("rich_text_content", richTextContent);
        // 保存
        let url = servicePath.addAdInfo
        let msg = '添加广告信息成功！'
        let errMsg = '添加广告信息失败！'

        if (adId) {
            if (postFile) {
                formData.append("post_url", postFile);
            }
            // 修改广告内容
            formData.append("adId", adId);
            url = servicePath.editAdInfo
            msg = '修改广告信息成功！'
            errMsg = '修改广告信息失败！'

        } else {
            formData.append("post_url", postFile);
        }
        message.loading({ content: '保存数据...' });
        axios({
            method: 'POST',
            url: url,
            data: formData,
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    message.success({ content: msg, key, duration: 2 });
                    setTimeout(() => {
                        props.history.push('/ad/list')
                    }, 2000)
                } else {
                    message.error({ content: errMsg, key, duration: 2 });
                }


            }
        ).catch((res) => {
            console.log("err", res)
            message.error({ content: '添加摄像头信息失败2！', key, duration: 2 });
        })
    };


    const layout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 15 },
    };
    const getUrl = values => {
        console.log("getUrl", values);

        var file = document.getElementById("upload")
        var preview = document.getElementById("preview");


        // 创建文件读取对象
        var reader = new FileReader();
        // 用户选择的文件列表
        // postFile = file.files[0];
        setPostFile(file.files[0])
        console.log("files[0]", file.files[0]);
        // 读取文件
        reader.readAsDataURL(file.files[0]);
        // 监听onload事件
        reader.onload = function () {
            console.log(reader.result);
            // 将读取的结果显示在页面中
            preview.src = reader.result;
            preview.style.display = 'block'
        }

    };
    const clSwitch = (checked, event) => {
        // setHideSW
        setHideSW(!hideSW)
    }
    const stSwitch = (checked, event) => {
        // 切换是否显示标题开关
        setShowTitle(!showTitle)
    }
    return (
        <>
            <Form {...layout} name="nest-messages" fields={fields} onFinish={onFinish} method="post" enctype="multipart/form-data" validateMessages={validateMessages}>
                <div>
                    <Row gutter={12}>
                        <Col span={20}>
                            {adId && <Form.Item name={['user', 'adId']} label="广告Id" >
                                <Input defaultValue={adId} maxLength='10' disabled={1} />
                            </Form.Item>}
                            <Form.Item name={['user', 'adTitle']} label="标题" rules={[{ required: true, message: '必填' }]}>
                                <Input defaultValue={adTitle} />
                            </Form.Item>
                            <Form.Item name={['user', 'description']} label="小标题（描述）" rules={[{ required: true, message: '必填' }]}>
                                <Input defaultValue={description} />
                            </Form.Item>
                            <Form.Item name={['user', 'showTitle']} label="显示大小标题" >
                                <Switch checked={showTitle} onClick={() => { stSwitch() }} />
                            </Form.Item>
                            <Form.Item name={['user', 'type_id']} label="广告类型：" rules={[{ required: true, message: '必填' }]}>
                                <Select style={{ width: '200px' }} placeholder="请选择广告类型" size="large" >
                                    <Option key={"1"} value={'small'}>小</Option>
                                    <Option key={"2"} value={'big'}>大</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name={['user', 'post_url']} label="海报图" >
                                <input onChange={() => { getUrl() }} type="file" placeholder="选择上传海报图" accept="image/*" id="upload" ></input>
                                {(adId && posturl) && <img style={{ width: '200px', height: 'auto', minHeight: '20px', padding: '20px 0' }} id="preview" src={servicePath.serverUrl + posturl} />}
                                <img style={{ width: '200px', height: 'auto', minHeight: '20px', padding: '20px 0', display: 'none' }} id="preview" src={servicePath.serverUrl + posturl} />
                                <div style={{ padding: '10px 0' }}>建议图片尺寸：(大：674*378px；小：308*266px)</div>
                            </Form.Item>
                            <Form.Item name={['user', 'hide']} label="是否显示" >
                                <Switch checked={hideSW} onClick={() => { clSwitch() }} />
                            </Form.Item>
                            <Form.Item label="广告页面详情内容" >
                                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                                    <Toolbar
                                        editor={editor}
                                        defaultConfig={toolbarConfig}
                                        mode="default"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    />
                                    <Editor
                                        defaultConfig={editorConfig}
                                        value={richTextContent}
                                        onCreated={setEditor}
                                        onChange={editor => setRichTextContent(editor.getHtml())}
                                        mode="default"
                                        style={{ height: '500px', overflowY: 'hidden' }}
                                    />
                                </div>
                            </Form.Item>

                        </Col>

                        <Col span={4}>
                            <Row>
                                <Col span={24}>
                                    {adId && <Button type="primary" size="large" htmlType="submit">修改广告信息</Button>}
                                    {!adId && <Button type="primary" size="large" htmlType="submit" >发布广告</Button>}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </div>
            </Form>
        </>
    )
}
export default AddAd